import { StyleSheet } from 'react-native';

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#ffffff',
  },
  formContent: {
    flex: 1,
    padding: 16,
  },
  inputStyle: {
    backgroundColor: '#fafafa',
  },
  topBack: {
    alignSelf: 'flex-start',
    marginLeft: 16,
  },
  header: {
    flexDirection: 'row',
    alignItems: 'center',
    height: 56,
    backgroundColor: '#fafafa',
  },
  headerText: {
    textAlign: 'center',
    flex: 1,
    fontSize: 16,
  },
  modalContent: {
    flex: 1,
    backgroundColor: 'white',
    borderTopLeftRadius: 8,
    borderTopRightRadius: 8,
    paddingHorizontal: 20,
    paddingTop: 16,
  },
  textContainer: {
    padding: 16,
  },
  titleText: {
    textAlign: 'left',
    fontSize: 14,
  },
  dropDownStyle: {
    backgroundColor: '#fafafa',
  },
  dropdownItemStyle: {
    justifyContent: 'flex-start',
  },
  dropDownContainer: {
    height: 40,
    paddingHorizontal: 10,
    marginBottom: 10,
    // marginHorizontal: 10,
  },
  description: {
    marginTop: 16,
    marginBottom: 8,
  },
  error: {
    color: 'red',
    fontSize: 12,
    margin: 5,
    marginHorizontal: 10,
  },
});

export default styles;
